var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('M_Settings_DB_Msg6'))+" ")]),_c('Dropdown',{style:('width:120px;'),attrs:{"items":_vm.item,"selected":_vm.usageState},on:{"change":_vm.select}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }